<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageAlt: page.headingImageAlt,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content vacancies-section">
			<filter-buttons
				v-if="categories.length > 1"
				:items="categories"
				:filter="filter"
				@change-filter="filter = $event"
			/>
			<vacancies-overview :items="vacanciesFiltered" :filter="filter" />
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:items="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const filter = ref('showAll');

const { data: vacanciesData } = await useWebsiteFetch('vacancies', {
	query: { language: locale.value },
	key: `${locale.value}/vacancies`,
});

const { vacancies } = vacanciesData.value;

const categories = [...new Set(vacancies.map(({ category }) => category))];

const vacanciesFiltered = computed(() => {
	if (filter.value === 'showAll') {
		return vacancies;
	}

	return [...vacancies].filter((item) => {
		if (!item.category) {
			return false;
		}

		return item.category === filter.value;
	});
});
</script>

<style lang="scss">
.vacancies-section {
	background-color: #d4c6b6;

	.filter-buttons {
		padding-bottom: 50px;
	}
}

@media (max-width: 920px) {
	.vacancies-section {
		.filter-buttons {
			padding-bottom: 20px;
		}
	}
}
</style>
